<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar ref="system-bar"/>
      </div>
      <div>
        <ViewHeader :title="$t('permissions.title')" />
      </div>
      <div class="flex-fill overflow-auto">
        <p
          v-if="permissionsConfig.data"
          class="text--secondary mx-5"
        >
          {{ permissionsConfig.data.title }}
        </p>

        <div class="mx-5">
          <v-alert
            v-if="directCallDisabled"
            color="warning"
            class="ma-5"
            :text="true"
            dense
          >
            <small>{{ $t('messages.cammer.available') }}</small>
          </v-alert>
        </div>

        <v-card
          :disabled="directCallDisabled"
          elevation="0"
          class="mb-4"
        >
          <v-list flat dense>
            <v-list-item-group multiple>
              <v-list-item
                v-if="channel === 'video'"
                @click="device.camera = !device.camera"
                class="px-5 py-2"
              >
                <div class="d-flex align-center">
                  <div class="mr-2">
                    <v-checkbox
                      v-model="device.camera"
                      @click="device.camera = !device.camera"
                      :on-icon="'$checked'"
                      :off-icon="'$uncheck'"
                      :disabled="directCallDisabled"
                      class="ma-0 pa-0"
                      hide-details
                    ></v-checkbox>
                  </div>
                  <div
                    class="mr-5"
                    style="margin-top: 6px"
                  >
                    <Icon
                      :size="20"
                      :color="device.camera ? '#2FA133' : 'rgba(0,0,0,.54)'"
                      :icon="device.camera ? 'video' : 'video-off'"
                    />
                  </div>
                  <div class="flex-fill">
                    {{ $t('permissions.camera') }}
                  </div>
                </div>
              </v-list-item>

              <v-list-item
                v-if="channel === 'video' || channel === 'voice'"
                @click="device.microphone = !device.microphone"
                :disabled="directCallDisabled"
                class="px-5"
              >
                <div class="d-flex align-center">
                  <div class="mr-2">
                    <v-checkbox
                      v-model="device.microphone"
                      @click="device.microphone = !device.microphone"
                      :on-icon="'$checked'"
                      :off-icon="'$uncheck'"
                      class="ma-0 pa-0"
                      hide-details
                    ></v-checkbox>
                  </div>
                  <div
                    class="mr-5"
                    style="margin-top: 6px"
                  >
                    <Icon
                      :width="20"
                      :color="device.microphone ? '#2FA133' : 'rgba(0,0,0,.54)'"
                      :icon="device.microphone ? 'microphone' : 'microphone-off'"
                    />
                  </div>
                  <div class="flex-fill">
                    {{ $t('permissions.micro') }}
                  </div>
                </div>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <!-- <div class="px-5">
          <TermsAndConditions />
        </div> -->
      </div>
      <v-dialog
        v-model="isCallActive"
        overlay-opacity="0"
        max-width="290"
      >
        <v-card>
          <v-card-title>
            <b>{{ $t('permissions.callActive.title') }}</b>
          </v-card-title>
          <v-card-text >
            <span>
              {{ $t('permissions.callActive.message') }}
            </span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="$refs['system-bar'].reset()"
              class="os-rounded"
            >
              <b>Salir</b>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="px-5 py-3">
        <v-btn
          v-if="btnPrimaryConfig.data"
          class="font-weight-bold mt-4 os-rounded"
          type="button"
          large
          block
          elevation="0"
          :color="btnPrimaryConfig.data.btn"
          :style="`color: ${btnPrimaryConfig.data.text}`"
          :loading="button.submit.loading"
          :disabled="button.submit.disabled || directCallDisabled"
          @click="getUserMedia"
        >
          {{ $t('basics.continue') }}
        </v-btn>
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
    <PermissionDenied ref="permisionDenied" />
    <section
      v-if="attentionType && attentionType.channels.length > 1 && $route.query.requestChannel"
      id="full-screen-modal"
    >
      <ChannelSelector
        ref="channel-selector"
        :attentionType="attentionType"
        :open="true"
        :persistent="true"
      />
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'

require('@/plugins/OT')

@Component({
  components: {
    PermissionDenied: () => import(/* webpackPrefetch: true */ '@/views/permissions/components/PermissionDenied.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    // TermsAndConditions: () => import(/* webpackPrefetch: true */ '@/components/TermsAndConditions.vue'),
    ViewHeader: () => import(/* webpackPrefetch: true */ '@/components/ViewHeader.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    ChannelSelector: () => import(/* webpackPrefetch: true */ '@/views/attention-types/components/ChannelSelector.vue')
  },
  computed: {
    ...mapState({
      channel: state => state.channel
    }),
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    },
    permissionsConfig () {
      return this.$organization.permissionsConfig()
    },
    cammerAvailableGroupByCategory () {
      return this.$store.state.organization.cammerAvailableGroupByCategory
    },
    category () {
      return this.$store.state.storage.category
    },
    device () {
      return this.$store.state.storage.device
    },
    widget () {
      return this.$store.state.widget
    },
    directCallDisabled () {
      const { isActive, data } = this.$organization.detectCammerAvailability()

      let disabled = false

      if (isActive && data?.permissions === 'true') {
        const categoryId = this.category && this.category.uuid ? this.category.id : null

        if (categoryId) {
          const categoryGroup = this.cammerAvailableGroupByCategory.find((item) => item.categoryId === categoryId)
          disabled = !categoryGroup
        } else {
          disabled = !this.cammerAvailableGroupByCategory.length
        }
      }

      return disabled
    },
    attentionType () {
      const data = this.$organization.attentionTypesConfig().data
      const options = data?.options ?? []

      return options.find((option) => option.id === 1) ?? null;
    }
  }
})
export default class Index extends Vue {
  data () {
    return {
      button: {
        submit: {
          loading: false,
          disabled: false
        }
      },
      isCallActive: false
    }
  }

  mounted () {
    this.ocGoogleAnalyticsInit()
    this.openTok.detectSupportedShareScreen()
  }

  disabledButton (value) {
    this.button.submit.disabled = value
  }

  toggleSubmitButton () {
    this.button.submit.loading = !this.button.submit.loading
    this.button.submit.disabled = !this.button.submit.disabled
  }

  stopMediaStreamTracks (mediaStream) {
    const tracks = mediaStream.getTracks()

    tracks.forEach((track) => {
      track.stop()
    })
  }

  saveAnalitycsEvent (hasPermissions) {
    const detail = hasPermissions ? 'El cliente habilitó los permisos de los dispositivos cámara y micrófono' : 'No fue posible el acceso a la cámara y micrófono'
    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: 'Permisos de dispositivos cámara y micrófono',
      detail,
      actionType: 'STAH',
      functionality: 5,
      historyInteractionType: hasPermissions ? 'OSIFDV' : 'OSNONV'
    })
  }

  ocGoogleAnalyticsInit() {
    OcGoogleAnalytics.getDataLayerConfig('init')
  }

  ocGoogleAnalyticsContinue() {
    OcGoogleAnalytics.getDataLayerConfig('continue')
  }

  getUserMedia () {
    this.toggleSubmitButton()

    if (this.widget.isBusy === true) {
      this.isCallActive = true
      return false
    }

    const options = {
      audioSource: this.channel === 'voice' || this.channel === 'video' ? true : false,
      videoSource: this.channel === 'video' ? true : false
    }

    OT.getUserMedia(options)
      .then((mediaStream) => {
        this.ocGoogleAnalyticsContinue()
        this.saveAnalitycsEvent(true)
        this.stopMediaStreamTracks(mediaStream)
        this.$storage.updateStorageData()
        this.$router.replace({ path: '/calling' })
      })
      .catch(() => {
        this.saveAnalitycsEvent(false)
        this.toggleSubmitButton()
        this.$refs.permisionDenied.toggleDialog()
      })
  }

  async getUserMediaPermission () {
    this.toggleSubmitButton()

    await this.$mediaDevices.getUserMedia()

    if (this.$mediaDevices.mediaStream) {
      this.$storage.updateStorageData()
      this.$router.replace({ path: '/calling' })
    } else {
      this.toggleSubmitButton()
      this.$refs.permisionDenied.toggleDialog()
    }
  }
}
</script>
